exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print {\n.no-print {\r\n        display: none;\n}\n}", ""]);

// exports
